import React, { useState, useEffect, useContext, useRef } from "react";
import "./css/BillerApp.css";
import "bootstrap/dist/css/bootstrap.css";
import Editing1 from "./images/MenuReg/Editing1.png";
import Redeye1 from "./images/Inventory/visible.png";
import close from "./images/Inventory/close.png";
import remove from "./images/Inventory/delete.png";
import right from "./images/right-arrow.png";
import close1 from "./images/Inventory/close (1).png";
import SideNav from "./SideNav";
import TopRootDiv from "./TopRootDiv";
import SherDineNav from "./SherDineNav";
import { useNavigate } from "react-router-dom";
import captain_json from "./js/captains.json";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import io from "socket.io-client";
import { DBContext } from "./DBContext";

const USER_RIGHT_FIELDS = [
	"editKOT",
	"cancelKOT",
	"moveTable",
	"generateBill",
	"takePayments",
	"addNewTable",
	"allowDiscount",
	"showOnlyMyOpenedtable",
	"allowSpecialDiscount",
	"allowComplimentary",
	"manageMasters",
	"viewReports",
	"manageSettings",
	"viewAuditLogs",
	"viewDashboard",
];

const areAllUserRightsSelected = (rights) =>
	USER_RIGHT_FIELDS.every((field) => Boolean(rights[field]));

function BillerApp() {
	const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

	const { logginedDB, userType } = useContext(DBContext);

	// //(logginedDB);

	const [biller, setBiller] = useState(false);
	const [captain, setCaptain] = useState(false);
	const [deliveryBoy, setDeliveryBoy] = useState(false);
	const [waiter, setWaiter] = useState(false);
	const toBiller = () => {
		setBiller(true);
		setCaptain(false);
		setDeliveryBoy(false);
		setWaiter(false);
	};
	const toCaptain = () => {
		setBiller(false);
		setCaptain(true);
		setDeliveryBoy(false);
		setWaiter(false);
	};
	const toDeliveryBoy = () => {
		setBiller(false);
		setCaptain(false);
		setDeliveryBoy(true);
		setWaiter(false);
	};
	const toWaiter = () => {
		setBiller(false);
		setCaptain(false);
		setDeliveryBoy(false);
		setWaiter(true);
	};

	const navigate = useNavigate();
	const toAdd = () => {
		navigate("/addcaptain");
	};

	const [captainsData, setCaptainsData] = useState([]);

	// Load captains.json data on component mount
	useEffect(() => {
		// Simulating loading JSON data (replace with actual fetch or import method)
		setCaptainsData(captain_json);
	}, []);

	const [isActive, setIsActive] = useState(false);
	const [userList, setUserList] = useState([]);

	useEffect(() => {
		// Initialize `isActive` state based on `userList` when it changes
		const activeStates = userList.reduce((acc, user) => {
			acc[user.id_user] = user.is_Active === 1;
			return acc;
		}, {});
		setIsActive(activeStates);
	}, [userList]);

	// Function to handle active/inactive toggle
	const handleIsActive = async (id, currentStatus) => {
		// Update the `isActive` state immediately
		setIsActive((prev) => ({
			...prev,
			[id]: !prev[id],
		}));

		try {
			const loggedInUser = localStorage.getItem('userName') || localStorage.getItem('USER') || '';
			const loggedInUserType = userType ? userType.replace(/^"|"$/g, '').trim() : '';
			// Make API request to update status
			const response = await axios.post(
				`${apiBaseUrl}/updateUserActive/${id}/${currentStatus === 1 ? 0 : 1
				}/${logginedDB}?loggedInUser=${loggedInUser}&loggedInUserType=${loggedInUserType}`
			);

			if (response.status === 200) {
				// handleGetUsersOnType();
			}
		} catch (error) {
			console.error("Error updating user status:", error);

			// Revert the change in case of an error
			setIsActive((prev) => ({
				...prev,
				[id]: currentStatus === 1,
			}));
		}
	};

	const [selectedUsers, setSelectedUsers] = useState([]);

	const [isCheckedAll, setIsCheckedAll] = useState(false);
	const [checkedItems, setCheckedItems] = useState(
		userList.map(() => false) // Initialize all as unchecked
	);

	// Handle "Select All" checkbox
	const handleIsCheckedAll = (e) => {
		const checked = e.target.checked;
		setIsCheckedAll(checked);
		setCheckedItems(userList.map(() => checked)); // Set all checkboxes to the same state

		// Update selectedUsers with all or none
		if (checked) {
			setSelectedUsers(userList.map((user) => user.id_user)); // Add all user ids
		} else {
			setSelectedUsers([]); // Clear selection
		}
	};

	// Handle individual checkboxes
	const handleIsChecked = (index, checked) => {
		const updatedCheckedItems = [...checkedItems];
		updatedCheckedItems[index] = checked;
		setCheckedItems(updatedCheckedItems);

		// Update "Select All" state if not all items are selected
		const allChecked = updatedCheckedItems.every((item) => item);
		setIsCheckedAll(allChecked);

		// Update selectedUsers based on checked state
		const updatedSelectedUsers = [...selectedUsers];
		const userId = userList[index].id_user;

		if (checked) {
			// Add the user id if checked
			updatedSelectedUsers.push(userId);
		} else {
			// Remove the user id if unchecked
			const userIndex = updatedSelectedUsers.indexOf(userId);
			if (userIndex !== -1) {
				updatedSelectedUsers.splice(userIndex, 1);
			}
		}

		setSelectedUsers(updatedSelectedUsers);
	};

	const [selectAllBiller, SetSelectAllBiller] = useState(false);
	const [selectAllCaptain, SetSelectAllCaptain] = useState(false);
	const [selectAllDeliveryBoy, SetSelectAllDeliveryBoy] = useState(false);
	const [selectAllWaiter, SetSelectAllWaiter] = useState(false);
	const [userRightModify, setUserRightModify] = useState({});

	const toSelectAll = (Sections) => {
		if (Sections === "Biller") {
			SetSelectAllBiller(!selectAllBiller);
			SetSelectAllCaptain(false);
			SetSelectAllDeliveryBoy(false);
			SetSelectAllWaiter(false);
		} else if (Sections === "Captain") {
			SetSelectAllBiller(false);
			SetSelectAllCaptain(!selectAllCaptain);
			SetSelectAllDeliveryBoy(false);
			SetSelectAllWaiter(false);
		} else if (Sections === "Delivery Boy") {
			SetSelectAllBiller(false);
			SetSelectAllCaptain(false);
			SetSelectAllDeliveryBoy(!selectAllDeliveryBoy);
			SetSelectAllWaiter(false);
		} else if (Sections === "Waiter") {
			SetSelectAllBiller(false);
			SetSelectAllCaptain(false);
			SetSelectAllDeliveryBoy(false);
			SetSelectAllWaiter(!selectAllWaiter);
		}
	};

	const [sideNav, setSideNav] = useState(false);
	const handleSideNav = (state) => {
		setSideNav(state);
	};
	const [falseState, setFalseState] = useState(null);

	const [action, setAction] = useState(false);

	const [userTypes, setUserTypes] = useState([]);

	// //(userTypes);

	const handleGetUserTypes = async () => {
		try {
			const loggedInUser = localStorage.getItem('userName') || localStorage.getItem('USER') || '';
			const response = await axios.get(
				`${apiBaseUrl}/getUserTypes/${logginedDB}/${userType}?loggedInUser=${loggedInUser}`
			);
			if (response.status == 200) {
				// console.log(response, "getUserTypes billerapp");

				setUserTypes(response.data);
				setUType({ userType: response.data[0].userType });
				handleGetUsersOnType(response.data[0].id);
			}
		} catch (error) {
			//(error);
		}
	};

	// useEffect(() => {
	//   if (logginedDB) {
	//     handleGetUserTypes();
	//   }
	//   // Connect to the WebSocket server
	//   const socket = io(apiBaseUrl);
	//   socket.on("updateUser", () => {
	//     //('Data updated, fetching new data...');
	//     handleGetUserTypes();
	//   });

	//   return () => {
	//     socket.disconnect();
	//   };
	// }, [apiBaseUrl, logginedDB]);



	const socketRef = useRef(null);

	// useEffect(() => {
	//   if (!logginedDB) return; // if not logged in, skip

	//   // connect socket
	//   socketRef.current = io(apiBaseUrl, {
	//     transports: ["websocket"], // faster than polling
	//   });

	//   // make sure old listeners are removed before adding new ones
	//   socketRef.current
	//     .off("updateUser")
	//     .on("updateUser", handleGetUserTypes());

	//   // cleanup on unmount
	//   return () => {
	//     socketRef.current.disconnect();
	//   };
	// }, [apiBaseUrl, logginedDB]);



	useEffect(() => {
		if (!logginedDB) return;

		handleGetUserTypes();

		socketRef.current = io(apiBaseUrl, {
			transports: ["websocket"],
		});

		// Event listeners
		const geteHandlerUserTypes = () => handleGetUserTypes();


		socketRef.current.on("connect", () => {
			console.log("Connected to server");
		});

		socketRef.current.on("disconnect", () => {
			console.log("Disconnected from server");
		});

		socketRef.current.on("connect_error", (error) => {
			console.error("Connection error:", error);
		});


		socketRef.current.on("updateUser", geteHandlerUserTypes);


		return () => {
			if (socketRef.current) {
				socketRef.current.off("updateUser", geteHandlerUserTypes);
				socketRef.current.disconnect();
			}
		};
	}, [apiBaseUrl, logginedDB]);


	const handleAction = () => {
		setAction(true);
		handleGetUserTypes();
	};

	// //(userRightModify);

	const [addUserType, setAddUserType] = useState(false);

	const handleUserRights = (type) => {
		setUserRightModify(type);
	};

	const [newUserTypeName, setNewUserTypeName] = useState("");

	// const handleSave = async () => {
	// 	if (addUserType) {
	// 		try {
	// 			const response = await axios.post(
	// 				`${apiBaseUrl}/newUserType/${newUserTypeName}/${logginedDB}`,
	// 				userRightModify
	// 			);
	// 			if (response.status == 200) {
	// 				setUserRightModify({});
	// 				setAddUserType(false);
	// 				toast.success(`${newUserTypeName} added!`, {
	// 					className: "custom-toast",
	// 					bodyClassName: "custom-toast-container",
	// 					closeButtonClassName: "custom-toast-close-button",
	// 					onClose: () => { },
	// 				});
	// 				handleGetUserTypes();
	// 			} else if (response.status == 409) {
	// 				toast.error(`${newUserTypeName} Already Exists!`, {
	// 					className: "custom-toast",
	// 					bodyClassName: "custom-toast-container",
	// 					closeButtonClassName: "custom-toast-close-button",
	// 					onClose: () => { },
	// 				});
	// 			}
	// 		} catch (error) {
	// 			//(error);
	// 		}
	// 	} else {
	// 		try {
	// 			const response = await axios.post(
	// 				`${apiBaseUrl}/updateUserType/${userRightModify.userType}/${logginedDB}`,
	// 				userRightModify
	// 			);
	// 			if (response.status == 200) {
	// 				setUserRightModify({});
	// 				setAddUserType(false);
	// 				toast.success(`${userRightModify.userType} rights updated!`, {
	// 					className: "custom-toast",
	// 					bodyClassName: "custom-toast-container",
	// 					closeButtonClassName: "custom-toast-close-button",
	// 					onClose: () => { },
	// 				});
	// 				handleGetUserTypes();
	// 			}
	// 		} catch (error) {
	// 			//(error);
	// 		}
	// 	}
	// };

	const handleSave = async () => {
		const loggedInUser = localStorage.getItem('userName') || localStorage.getItem('USER') || '';
		const loggedInUserType = userType ? userType.replace(/^"|"$/g, '').trim() : '';
		if (addUserType) {
			try {
				const response = await axios.post(
					`${apiBaseUrl}/newUserType/${newUserTypeName}/${logginedDB}?loggedInUser=${loggedInUser}&loggedInUserType=${loggedInUserType}`,
					userRightModify
				);
				// This will only be reached for 2xx responses
				setUserRightModify({});
				setAddUserType(false);
				toast.success(`${newUserTypeName} added!`, {
					className: "custom-toast",
					bodyClassName: "custom-toast-container",
					closeButtonClassName: "custom-toast-close-button",
					onClose: () => { },
				});
				handleGetUserTypes();
			} catch (error) {
				// Check if it's a 409 error (duplicate)
				if (error.response && error.response.status === 409) {
					toast.error(`${newUserTypeName} Already Exists!`, {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
				} else {
					// Handle other errors
					toast.error("Error adding user type!", {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
				}
			}
		} else {
			try {
				const response = await axios.post(
					`${apiBaseUrl}/updateUserType/${userRightModify.userType}/${logginedDB}?loggedInUser=${loggedInUser}&loggedInUserType=${loggedInUserType}`,
					userRightModify
				);
				if (response.status == 200) {
					setUserRightModify({});
					setAddUserType(false);
					toast.success(`${userRightModify.userType} rights updated!`, {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
					handleGetUserTypes();
				}
			} catch (error) {
				toast.error("Error updating user type!", {
					className: "custom-toast",
					bodyClassName: "custom-toast-container",
					closeButtonClassName: "custom-toast-close-button",
					onClose: () => { },
				});
			}
		}
	};

	const handleToDeleteUserType = async (type) => {
		console.log(type, "handleToDeleteUserType");

		const userConfirmed = window.confirm(
			`Are you sure to delete "${type.userType}"?`
		);

		if (!userConfirmed) {
			return;
		}

		try {
			const loggedInUser = localStorage.getItem('userName') || localStorage.getItem('USER') || '';
			const loggedInUserType = userType ? userType.replace(/^"|"$/g, '').trim() : '';
			const response = await axios.post(
				`${apiBaseUrl}/deleteUserType/${type.id}/${logginedDB}?loggedInUser=${loggedInUser}&loggedInUserType=${loggedInUserType}`
			);
			if (response.status == 200) {
				toast.success(`Successfully deleted ${type.userType}!`, {
					// toast.info(`No Backend api`, {
					className: "custom-toast",
					bodyClassName: "custom-toast-container",
					closeButtonClassName: "custom-toast-close-button",
					onClose: () => { },
				});
				handleGetUserTypes();
			} else if (response.status == 404) {
				// 
				toast.warnimg(`User type not found`, {
					className: "custom-toast",
					bodyClassName: "custom-toast-container",
					closeButtonClassName: "custom-toast-close-button",
					onClose: () => { },
				});
			}
		} catch (error) {
			toast.warning(`Something went wrong. Please try again later`, {
				className: "custom-toast",
				bodyClassName: "custom-toast-container",
				closeButtonClassName: "custom-toast-close-button",
				onClose: () => { },
			});
		}
	};

	// const handleChangeRights = (e, field) => {

	//     const val = e.target.checked
	//     //(val);
	//     setUserRightModify((prev) => ({
	//         ...prev,
	//         [field]: val
	//     }))
	// }

	const handleChangeRights = (e, field) => {
		const val = e.target.checked;
		setUserRightModify((prev) => ({
			...prev,
			[field]: val,
		}));
	};

	const handleSelectAll = (e) => {
		const val = e.target.checked;
		setUserRightModify((prev) => {
			const updated = { ...prev };
			USER_RIGHT_FIELDS.forEach((key) => {
				updated[key] = val;
			});
			return updated;
		});
	};

	const [uType, setUType] = useState(null);

	//(uType);

	// const [usersOnType,setUsersOnType] = useState(null)

	const handleGetUsersOnType = async (id) => {
		try {
			const loggedInUser = localStorage.getItem('userName') || localStorage.getItem('USER') || '';
			const response = await axios.get(
				`${apiBaseUrl}/getUsersOnType/${id}/${logginedDB}?loggedInUser=${loggedInUser}`
			);
			if (response.status === 200) {
				if (response.data.length > 0) {
					setUserList(response.data);
				} else {
					setUserList([]);
				}
			}
		} catch (error) { }
	};

	// useEffect(() => {
	//     if (usersOnType) {
	//         handleGetUsersOnType(usersOnType)
	//     }
	// },[usersOnType])

	const handleList = async (type) => {
		setUType(type);
		handleGetUsersOnType(type.id);
		setCheckedItems(userList.map(() => false));
		setIsCheckedAll(false);
	};

	const handleToDeleteUser = async () => {
		if (selectedUsers.length > 0) {
			const userConfirmed = window.confirm(`Delete selected users?`);

			if (!userConfirmed) {
				return;
			}
			try {
				const loggedInUser = localStorage.getItem('userName') || localStorage.getItem('USER') || '';
				const loggedInUserType = userType ? userType.replace(/^"|"$/g, '').trim() : '';
				const response = await axios.post(
					`${apiBaseUrl}/deleteUsers/${logginedDB}?loggedInUser=${loggedInUser}&loggedInUserType=${loggedInUserType}`,
					selectedUsers
				);
				if (response.status === 200) {
					toast.success(`Successfully deleted!`, {
						className: "custom-toast",
						bodyClassName: "custom-toast-container",
						closeButtonClassName: "custom-toast-close-button",
						onClose: () => { },
					});
					if (uType) {
						handleGetUsersOnType(uType.id);
					}
				}
			} catch (error) { }
		} else {
			alert("Select any user!");
		}
	};

	const handleToEdit = (user) => {
		navigate("/AddCaptain", {
			state: {
				userDetails: user,
				type: uType.userType,
			},
			replace: true,
		});
	};

	const [viewUserDetails, setViewUserDetails] = useState(null);
	const [isExiting, setIsExiting] = useState(false);

	const handleToView = (user) => {
		setViewUserDetails(user);
		setIsExiting(false);
	};

	const handleClose = () => {
		setIsExiting(true);
		setTimeout(() => {
			setViewUserDetails(null);
		}, 300); // Match the animation duration
	};

	return (
		<div className="TableRegMainDiv">
			<SherDineNav
				sideNav={(state) => handleSideNav(state)}
				falseState={falseState}
			/>
			<div className="w-full bg-[#f5f5f5] flex gap-3 h-full overflow-hidden">
				<div className="w-max h-full z-[9999]">
					<SideNav
						focus={"User"}
						state={sideNav}
						falseState={(state) => setFalseState(state)}
					/>
				</div>
				<div className="w-full h-full flex flex-col pr-3 pl-0 pb-3 pt-0 gap-3 overflow-hidden">
					<div className="pr-3 h-max w-full bg-[#fff] borderBottom">
						<TopRootDiv image={"Menu Management"} root={["User Management"]} />
					</div>
					<div className="w-full h-full flex flex-col gap-3 relative overflow-hidden">
						<div className="MenuReg_buttons h-max">
							<span className="SyncCodeSpan">Sync Code :</span>
						</div>
						<div className="w-full flex h-max rounded-t bg-[#fff]">
							<div className="w-10/12 flex overflow-auto">
								{userTypes.map((type, index) => (
									<div
										key={index}
										className={`font-nunito text-[1rem] font-[600] pt-3 pb-3 pl-5 pr-5 cursor-pointer ${uType && (uType.userType || uType) === type.userType
											? "MenuCategoryActive"
											: "MenuCategoryNotActive"
											}`}
										onClick={() => handleList(type)}
									>
										{type.userType}
									</div>
								))}
							</div>
							<div className="w-2/12 flex font-nunito font-[600] justify-end items-center gap-2 pr-3 text-[.9rem]">
								<button
									className="bg-[#0008B4] text-[#fff] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3"
									onClick={toAdd}
								>
									Add
								</button>
								<button
									className="bg-[#fff] loginBorder text-[#0008B4] pt-1 pb-1 pl-3 pr-3 rounded-[.313rem]"
									onClick={handleAction}
								>
									Action
								</button>
							</div>
						</div>
						{uType && userList.length > 0 ? (
							<div className="w-full h-full font-nunito flex flex-col gap-1 bg-[#fff] overflow-hidden">
								<div className="w-full text-center font-[600] flex bg-[#e0e0e0] rounded-t">
									<div className="w-1/12 p-3">
										<input
											type="checkbox"
											checked={isCheckedAll}
											onChange={handleIsCheckedAll}
										/>
									</div>
									<div className="w-3/12 p-3 text-left">
										{uType.userType} Name
									</div>
									<div className="w-2/12 p-3">User Name</div>
									<div className="w-2/12 p-3">Usercode</div>
									<div className="w-2/12 p-3">Active/Inactive</div>
									<div className="w-2/12 p-3">Action</div>
								</div>
								<div className="w-full flex flex-col overflow-auto customScroll">
									{userList.length > 0 &&
										userList.map((list, index) => (
											<div
												className="w-full text-center font-[400] flex"
												key={index}
											>
												<div className="w-1/12 p-3">
													<input
														type="checkbox"
														checked={checkedItems[index]}
														onChange={(e) =>
															handleIsChecked(index, e.target.checked)
														}
													/>
												</div>
												<div className="w-3/12 p-3 text-left">
													{list.userFullName}
												</div>
												<div className="w-2/12 p-3">{list.userName}</div>
												<div className="w-2/12 p-3">{list.userCode}</div>
												<div className="w-2/12 p-3 flex justify-center items-center relative">
													<input
														type="checkbox"
														id="active_inactive_checkbox"
														checked={isActive[list.id_user] || false}
														readOnly
													/>
													<div
														className="active_inactive_div"
														onClick={() =>
															handleIsActive(list.id_user, list.is_Active)
														}
													></div>
												</div>
												{checkedItems[index] ? (
													<div className="w-2/12 p-2 flex justify-center items-center gap-2">
														<img
															className="w-[1rem] cursor-pointer"
															src={remove}
															alt=""
															onClick={handleToDeleteUser}
														/>
													</div>
												) : (
													<div className="w-2/12 p-2 flex justify-center items-center gap-2">
														<img
															className="w-[1rem] opacity-75 cursor-pointer"
															src={Redeye1}
															alt=""
															onClick={() => handleToView(list)}
														/>
														<img
															className="w-[1rem] cursor-pointer"
															src={Editing1}
															alt=""
															onClick={() => handleToEdit(list)}
														/>
													</div>
												)}
											</div>
										))}
								</div>
							</div>
						) : (
							uType &&
							userList.length < 1 && (
								<div className="p-2 font-nunito">
									{uType.userType} not registered yet!
								</div>
							)
						)}
						{action && (
							<div className="absolute inset-0 h-full bg-[#000] bg-opacity-70 flex justify-center items-center p-20 font-nunito">
								<div className="billerApp_userRightsModal w-full h-full flex flex-col bg-[#fff] rounded p-2">
									<div className="billerApp_userRightsHeader w-full h-max flex p-2">
										<div className="flex  ml-3 justify-between w-full">
											<span className="font-[700]">
												{Object.keys(userRightModify).length > 0 && !addUserType
													? userRightModify.userType
													: userRightModify && addUserType && "Add Usertype"}
											</span>

											{userRightModify.userType && userRightModify.userType !== "Add Usertype" && (
												<div className="AddCaptain_rights_div_checkbox">
													<input
														type="checkbox"
														checked={areAllUserRightsSelected(userRightModify)}
														onChange={handleSelectAll}
													/>
													{/* {console.log(
														"Select All checked:",
														userRightModify
													)} */}

													<span>All</span>
												</div>
											)

											}


										</div>
										<div className="flex justify-end items-start w-max">
											<img
												className="w-[1rem] cursor-pointer"
												src={close}
												alt=""
												onClick={() => {
													setAction(false);
													setUserRightModify({});
													setAddUserType(false);
												}}
											/>
										</div>
									</div>
									{Object.keys(userRightModify).length > 0 || addUserType ? (
										<div className="billerApp_userRightsBody h-full w-full overflow-auto">
											{addUserType && (
												<div className="flex justify-between  p-2">

													<input
														className="p-1 focus:outline-none border rounded-0 font-[600] placeholder:font-[400]"
														type="text"
														placeholder="Usertype"
														value={newUserTypeName}
														onChange={(e) => setNewUserTypeName(e.target.value)}
													/>

													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={areAllUserRightsSelected(userRightModify)}
															onChange={handleSelectAll}
														/>
														{/* {console.log(
															"Select All checked:",
															userRightModify
														)} */}

														<span>All</span>
													</div>


												</div>
											)}
											<div className="AddCaptain_rights">
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														Edit KOT
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.editKOT}
															onChange={(e) => handleChangeRights(e, "editKOT")}
														/>
														<span>YES</span>
													</div>
												</div>

												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														Cancel KOT
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.cancelKOT}
															onChange={(e) =>
																handleChangeRights(e, "cancelKOT")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														Move Table
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.moveTable}
															onChange={(e) =>
																handleChangeRights(e, "moveTable")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														Generate Bill
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.generateBill}
															onChange={(e) =>
																handleChangeRights(e, "generateBill")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														Take Payments ( Pending Bill )
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.takePayments}
															onChange={(e) =>
																handleChangeRights(e, "takePayments")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														Add New Tables
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.addNewTable}
															onChange={(e) =>
																handleChangeRights(e, "addNewTable")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														Allow Discount ( Applicable for Dine-in orders only)
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.allowDiscount}
															onChange={(e) =>
																handleChangeRights(e, "allowDiscount")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														Show only my opened Table
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.showOnlyMyOpenedtable}
															onChange={(e) =>
																handleChangeRights(e, "showOnlyMyOpenedtable")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														Allow Special Discount
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.allowSpecialDiscount}
															onChange={(e) =>
																handleChangeRights(e, "allowSpecialDiscount")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														Allow Complimentary
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.allowComplimentary}
															onChange={(e) =>
																handleChangeRights(e, "allowComplimentary")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														Manage Masters
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.manageMasters}
															onChange={(e) =>
																handleChangeRights(e, "manageMasters")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														View Reports
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.viewReports}
															onChange={(e) =>
																handleChangeRights(e, "viewReports")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														Manage Settings
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.manageSettings}
															onChange={(e) =>
																handleChangeRights(e, "manageSettings")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														View Audit Logs
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.viewAuditLogs}
															onChange={(e) =>
																handleChangeRights(e, "viewAuditLogs")
															}
														/>
														<span>YES</span>
													</div>
												</div>
												<div className="AddCaptain_rights_div">
													<div className="AddCaptain_rights_div_span">
														View Dashboard
													</div>
													<div className="AddCaptain_rights_div_checkbox">
														<input
															type="checkbox"
															checked={userRightModify.viewDashboard}
															onChange={(e) =>
																handleChangeRights(e, "viewDashboard")
															}
														/>
														<span>YES</span>
													</div>
												</div>
											</div>
										</div>
									) : (
										<div className="w-full h-full flex flex-col pl-2 pb-2 pr-2 gap-1 text-center overflow-auto bg-[#fff]">
											<div className="flex w-full gap-1 font-[700] sticky top-0 bg-[#fff] pt-2">
												<div className="w-1/4 bg-[#c6c6c6] p-2">SI</div>
												<div className="w-1/4 bg-[#c6c6c6] p-2 text-left">
													User Type
												</div>
												<div className="w-1/4 bg-[#c6c6c6] p-2">User Right</div>
												<div className="w-1/4 bg-[#c6c6c6] p-2">Action</div>
											</div>
											<div className="w-full flex flex-col gap-1">
												{userTypes.map((type, index) => (
													<div className="flex w-full gap-1" key={index}>
														<div className="w-1/4 bg-[#f7f7f7] p-2">
															{index + 1}
														</div>
														<div className="w-1/4 bg-[#f7f7f7] p-2 text-left">
															{type.userType}
														</div>
														<div className="w-1/4 bg-[#f7f7f7] p-2">
															<button
																className="billerApp_userRights_Btn"
																onClick={() => handleUserRights(type)}
															>
																User Rights
															</button>
														</div>
														<div className="w-1/4 bg-[#f7f7f7] flex justify-center items-center p-2">
															{type.userType === "Captain" || type.userType === "Admin" || type.userType === "super admin" || type.userType === "Super Admin" ? (
																<span>-</span> 
															) : (
																<img
																	className="w-[1rem] cursor-pointer"
																	src={remove}
																	alt=""
																	onClick={() => handleToDeleteUserType(type)}
																/>
															)}
														</div>
													</div>
												))}
											</div>
										</div>
									)}
									{Object.keys(userRightModify).length > 0 || addUserType ? (
										<div className="billerApp_userRightsFooter w-full h-max flex p-2 justify-end items-center gap-2">
											<button
												className="pl-4 pr-4 pt-1 pb-1 loginBorder text-[#0008B4] rounded-[.313rem]"
												onClick={() => {
													setUserRightModify({});
													setAddUserType(false);
												}}
											>
												Cancel
											</button>
											<button
												className="pl-4 pr-4 pt-1 pb-1 bg-[#0008B4] loginBorder text-[#fff] rounded-[.313rem]"
												onClick={handleSave}
											>
												Save
											</button>
										</div>
									) : (
										<div className="w-full h-max flex p-2 justify-end items-end gap-2">
											<button
												type="button"
												onClick={() => {
													setAddUserType(true);
													setUserRightModify({});
												}}
												className=" pr-3 pl-3 pt-1 pb-1 rounded-[.313rem] border font-[600] shadow-md hover:bg-[#0008B4] hover:text-[#fff] focus:outline-none"
											>
												Add
											</button>
										</div>
									)}
								</div>
							</div>
						)}
						{viewUserDetails && (
							<div
								className={`absolute right-0 h-full w-max flex justify-center items-center w-max bg-transparent pl-0 pb-3 pt-3 pr-0 gap-2 ${isExiting ? "slide-out" : "slide-in"
									}`}
							>
								<div
									className="h-8 w-max flex justify-center items-center pl-1 pr-1 pt-2 pb-2 bg-[#464545] cursor-pointer transition-all duration-300 hover:h-16"
									onClick={handleClose}
								>
									<img className="w-[.5rem] h-[1rem]" src={right} alt="" />
								</div>
								<div className="w-[30rem] rounded-l-lg shadow-2xl border-l-2 border-t bg-[#f8f8f8] h-full">
									{/* {viewUserDetails} */}
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
			{/* ........................................mobileView................................ */}
			<div className="w-full h-full flex flex-col sm:!hidden overflow-hidden">
				oijhoijhoihoihnnlkmiopj
			</div>
		</div>
	);
}

export default BillerApp;
